import cn from '@/utils/cn.ts'
import css from './mdmListValue.module.css'
import { ReactNode } from 'react'
import useDropdownUnderIconCtrl from '@/shared/Dropdowns/hooks/useDropdownUnderIconCtrl.ts'
import DropdownUnderThreeDots from '@/shared/Dropdowns/DropdownUnderThreeDots'

interface IProps {
  name: string
  icon: ReactNode
  menuOptions?: ReactNode
  onClick?: () => void
}

const MDMListValue = (props: IProps) => {
  const threeDotsMenuCtrl = useDropdownUnderIconCtrl()

  return (
    <div
      className={cn('inline-flex-gap center flex-space-between width100', css.wrapper)}
      onClick={props.onClick}
      onContextMenu={(ev) => {
        if (!props.menuOptions) return

        ev.stopPropagation()
        ev.preventDefault()
        threeDotsMenuCtrl.toggle()
      }}
    >
      <div className="inline-flex-gap center gap16">
        {props.icon}
        <p className="text-nm">{props.name}</p>
      </div>
      {props.menuOptions && (
        <DropdownUnderThreeDots
          open={threeDotsMenuCtrl.open}
          setOpen={threeDotsMenuCtrl.setOpen}
          ref={threeDotsMenuCtrl.ref}
          position="left"
          style={{ overflow: 'visible' }}
        >
          {props.menuOptions}
        </DropdownUnderThreeDots>
      )}
    </div>
  )
}

export default MDMListValue
